import { campaignOptimizeObjectiveLabels, OUTCOME_LEADS } from '../../../../../constants/campaigns'

export const objectiveLabelsForOptimizedImpressions = {
  ...campaignOptimizeObjectiveLabels,
  // For combined campaign edit budget form we use reusable labels, but with minor overrides
  [OUTCOME_LEADS]: 'lead'
}
